export default values => ({
  ...values,
  clientId: values.clientId || '',
  clientPersonType: values.clientPersonType || null
});
